<template>
  <div class="nav" :style="{bottom}" v-scroll="handleScroll">
    <ul ref="wrapper">
      <el-popover :append-to-body="false" placement="left-end" popper-class="popper__contact" trigger="click" :offset="showBackTopIcon ? -148: -74">
        <div class="contact">
          <h5 class="contact__title">专属客服经理</h5>
          <div class="contact__people">
            <p class="contact__people__name">{{customer.username}}</p>
            <p class="contact__people__phone">{{customer.mobile}}</p>
            <p class="contact__people__email">{{customer.email}}</p>
          </div>
          <img class="contact__code" :src="customer.qr_code" />
          <p class="contact__desc">企业微信二维码</p>
        </div>
        <li class="nav__icon" slot="reference">
          <span class="ficon ficon-kefu"></span>
        </li>
      </el-popover>
      <el-popover :append-to-body="false" placement="left-end" popper-class="popper__contact" trigger="click" :offset="showBackTopIcon ? -74: 0">
        <div class="qrcode">
          <ul class="qrcode__nav">
            <li class="qrcode__nav__item" :class="{ 'qrcode__nav__item--active': qrcodeNav == 'official'}" @click="qrcodeNav = 'official'">公众号</li>
            <li class="qrcode__nav__item" :class="{ 'qrcode__nav__item--active': qrcodeNav == 'miniapp'}" @click="qrcodeNav = 'miniapp'">小程序</li>
            <li class="qrcode__nav__item" :class="{ 'qrcode__nav__item--active': qrcodeNav == 'video'}" @click="qrcodeNav = 'video'">视频号</li>
          </ul>
          <div class="qrcode__code__wrapper">
            <transition enter-active-class="animate__animated animate__fadeIn">
              <el-image v-if="qrcodeNav == 'official'" class="qrcode__code" fit="contain" src="~@/assets/img/global/official_qrcode.jpg" />
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <el-image v-if="qrcodeNav == 'miniapp'" class="qrcode__code" fit="contain" src="~@/assets/img/global/mini_qrcode.jpg" />
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <el-image v-if="qrcodeNav == 'video'" class="qrcode__code" fit="contain" src="~@/assets/img/global/video_qrcode.jpg" />
            </transition>
          </div>
          <div class="qrcode__desc">{{ qrcodeNav == 'miniapp' ? '微信扫码查看' : '微信扫码关注' }}</div>
        </div>
        <li class="nav__icon" slot="reference">
          <span class="ficon ficon-erweima"></span>
        </li>
      </el-popover>
      <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
        <li class="nav__icon back-top" v-show="showBackTopIcon" @click="handleBackTop">
          <span class="ficon ficon-fanhuidingduan"></span>
        </li>
      </transition>
    </ul>
  </div>
</template>

<script>
import {
  getScrollTopPosition,
  moveToScrollTop,
  moveToScrollTopAnimate,
} from "@/utils/getScrollTop";
import { getScreenWH } from "@/utils/helpers";
import bezierEasing from "@/utils/bezier-easing.js";

import { getExclusiveCustomerService } from "~/services/product";
import useRequest from "@/composables/useRequest";

const bezierEasingValue = "0.25, 0.8, 0.5, 1";

export default {
  name: "FixedHoverNav",
  data() {
    return {
      scrollTop: 0,
      windowHeight: 0,
      bezierEasingArray: bezierEasingValue.split(","),
      offset: 0,

      qrcodeNav: "official",
    };
  },
  setup() {
    const { state: customer, error } = useRequest(getExclusiveCustomerService, {});
    return { customer };
  },
  props: {
    bottom: {
      type: String,
      default: "30px",
    },
  },
  computed: {
    showBackTopIcon() {
      return this.scrollTop > this.windowHeight;
    },
  },
  mounted() {
    this.handleScroll();
    this.offset = -this.$refs.wrapper.offsetHeight;
  },
  methods: {
    handleScroll() {
      this.windowHeight = getScreenWH().h;
      this.scrollTop = getScrollTopPosition();
    },
    handleBackTop() {
      this.scrollTo();
    },
    scrollTo() {
      moveToScrollTopAnimate();
    },
  },
};
</script>

<style lang="scss" scoped>

.nav {
  position: fixed;
  // bottom: 30px;
  right: 50px;
  margin-right: 30px;
  width: 70px;
  height: 222px;
  text-align: center;
  z-index: 99;
  &__icon {
    width: 64px;
    height: 64px;
    cursor: pointer;
    background: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    position: relative;
    transition: 0.3s all ease;
    &:hover {
      background-color: #f25b3b;
      color: #fff;
      .ficon {
        // col
      }
    }
  }
  ::v-deep {
    .popper__contact {
      padding: 0;
      border: none;
    }
  }
}
.ficon-kefu,
.ficon-erweima {
  font-size: 24px;
}

// 联系人 popver
.contact {
  width: 258px;
  padding-bottom: 32px;
  overflow: hidden;
  &__title {
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #f25b3b;
    border-radius: 4px 4px 0 0;
    margin-bottom: 14px;
  }
  &__people {
    position: relative;
    margin-left: 18px;
    color: #212529;
    font-size: 16px;
    margin-bottom: 8px;
    &::before {
      content: "";
      position: absolute;
      height: 85%;
      top: 50%;
      transform: translateY(-50%);
      width: 2px;
      background-color: #f25b3b;
    }
    > * {
      padding-left: 7px;
    }
    &__name {
      font-size: 18px;
      font-weight: 500;
      padding-bottom: 6px;
    }
  }
  &__code {
    width: 140px;
    height: 140px;
    margin-bottom: 5px;
    margin: 0 auto;
    display: block;
  }
  &__desc {
    color: #868e96;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }
}

// 二维码 popver
.qrcode {
  width: 258px;
  padding-bottom: 38px;
  &__nav {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 28px;
    &__item {
      height: 42px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 0 0;
      transition: 0.2s all ease;
      user-select: none;
      cursor: pointer;
      color: #868e96;
      font-size: 16px;
      font-weight: 600;
      &--active {
        color: #fff;
        background: #f25b3b;
      }
    }
  }
  &__code {
    width: 190px;
    height: 190px;
    display: block;
    &__wrapper {
      width: 190px;
      height: 190px;
      overflow: hidden;
      margin: 0 auto 16px;
    }
  }
  &__desc {
    color: #868e96;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }
}

</style>